import { createAction, createSlice, } from "@reduxjs/toolkit";
import { set } from "react-hook-form";
const initialState = {
    loading: true,
    error: "",
    questionBankDetails: {},
    courseQuestionBank:{},
    current: {},
    pagination: {},
    section: [],
    chapter: [],
    group: {}
};

export const questionBankSlice = createSlice({
    name: "questionBank",
    initialState,
    reducers: {
        setIsLoading(state, action) {
            state.loading = action.payload;
        },
        setQuestionBank(state, action) {
            let data = action.payload;
            state.questionBankDetails = data;
            state.pagination = { ...action.payload, data: null };
            state.loading = false;
        },
        setCourseQuestion(state,action){
            let data = action.payload;
            state.courseQuestionBank = data;
            state.pagination = { ...action.payload, data: null };
            state.loading = false;
        },
        deleteQuestion(state, action) {
            let  { id, questionBank }  = action.payload;
            if(questionBank){
                state.questionBankDetails.data = state.questionBankDetails.data.filter(e => e.id != id);
            } else{
                state.courseQuestionBank.data = state.courseQuestionBank.data.filter(e =>e.id != id);
            }
        },
        setCurrentQuestion(state, action) {
            state.current = action.payload;
            state.loading = false;
        },
        setSection(state, action) {
            let data = action.payload;
            state.section = data;
            state.loading = false;
        },

        setChapter(state, action) {
            let data = action.payload;
            state.chapter = data;
            state.loading = false;
        },

        setGroup(state, action) {
            let data = action.payload;
            state.group = data;
            state.loading = false;
        },
    },
});

export const questionBankActions = {
    loadQuestionBank: createAction(`${questionBankSlice.name}/loadQuestionBank`, (payload) => ({ payload })),
    loadCourseQuestion:createAction(`${questionBankSlice.name}/loadCourseQuestion`,(payload)=>({
    payload })),
    loadCurrentQuestion: createAction(`${questionBankSlice.name}/changeCurrentQuestion`, (payload) => ({ payload })),
    saveCurrentQuestion: createAction(`${questionBankSlice.name}/saveQuestion`, (payload) => ({ payload })),
    createQuestion: createAction(`${questionBankSlice.name}/createQuestion`, (payload) => ({ payload })),
    removeQuestion: createAction(`${questionBankSlice.name}/removeQuestion`, (payload) => ({ payload })),
    updateStatus: createAction(`${questionBankSlice.name}/updateStatus`, (payload) => ({ payload })),
    loadSection: createAction(`${questionBankSlice.name}/loadSection`, (payload) => ({ payload })),
    loadChapter: createAction(`${questionBankSlice.name}/loadChapter`, (payload) => ({ payload })),
    loadGroup: createAction(`${questionBankSlice.name}/loadGroup`, (payload) => ({ payload })),
    deleteQuestion: questionBankSlice.actions.deleteQuestion,
    setQuestionBank: questionBankSlice.actions.setQuestionBank,
    setCourseQuestion:questionBankSlice.actions.setCourseQuestion,
    setCurrentQuestion: questionBankSlice.actions.setCurrentQuestion,
    setSection: questionBankSlice.actions.setSection,
    setChapter: questionBankSlice.actions.setChapter,
    setGroup: questionBankSlice.actions.setGroup

};
export const getQuestionBank = (state) => state.questionBank.questionBankDetails;
export const getCourseQuestion = (state) => state.questionBank.courseQuestionBank;
export const getCurrentQuestion = (state) => state.questionBank.current;
export const isLoading = (state) => state.questionBank.loading;
export const getPagination = (state) => state.questionBank.pagination;

export const getSection = (state) => state.questionBank.section;
export const getChapter = (state) => state.questionBank.chapter;
export const getGroup = (state) => state.questionBank.group;
export default questionBankSlice.reducer;
